import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React from "react";
import { couleurs } from "../../theme/tokens";
import PageStatique from "../_Base/PageStatique";

/**
 * Page de support — exigée par Apple/Google (URL de l'assistance) pour la
 * soumission de l'application mobile. Contenu identique pour toutes les
 * villes : page de PLATEFORME, pas propre à une municipalité (voir
 * PageStatique) — accessible aussi bien sur liencitoyen.com que sur le
 * sous-domaine d'une ville, sans connexion, à /support.
 */
export default function Support() {

    return (
        <PageStatique>
            <Typography className='page-title' sx={{ fontWeight:'900', color:couleurs.BleuClair, lineHeight:'55px' }}>Assistance</Typography>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="subtitle1">
                        Une question sur votre compte, une alerte, ou un problème avec le site
                        Web ou l'application mobile Lien Citoyen ? Vous êtes au bon endroit.
                    </Typography>

                    <Typography variant="h5" sx={{pt:3}}>NOUS ÉCRIRE</Typography>
                    <Typography variant="body1">
                        Pour toute question, écrivez-nous à{" "}
                        <a href="mailto:info@liencitoyen.com">info@liencitoyen.com</a>. Précisez
                        si possible votre municipalité et, pour un problème technique, l'appareil
                        que vous utilisez (téléphone, tablette, ordinateur).
                    </Typography>

                    <Typography variant="h5" sx={{pt:3}}>JE N'AI PAS REÇU UNE ALERTE</Typography>
                    <Typography variant="body1">
                        Vérifiez d'abord vos préférences de notification dans votre profil : les
                        canaux choisis (SMS, courriel, appel vocal, notification) et les types
                        d'alertes auxquels vous êtes abonné(e). Assurez-vous aussi que votre
                        numéro de téléphone et votre adresse courriel sont à jour, et que les
                        notifications de l'application sont autorisées dans les réglages de votre
                        téléphone.
                    </Typography>

                    <Typography variant="h5" sx={{pt:3}}>J'AI OUBLIÉ MON MOT DE PASSE</Typography>
                    <Typography variant="body1">
                        Sur l'écran de connexion, utilisez le lien « Mot de passe oublié » : un
                        courriel de réinitialisation vous sera envoyé, valide 6 heures.
                    </Typography>

                    <Typography variant="h5" sx={{pt:3}}>COMMENT MODIFIER MES RENSEIGNEMENTS</Typography>
                    <Typography variant="body1">
                        Votre profil (site Web ou application mobile) vous permet de mettre à
                        jour votre adresse, votre numéro de téléphone, vos préférences de
                        notification et votre mot de passe en tout temps.
                    </Typography>

                    <Typography variant="h5" sx={{pt:3}}>MA MUNICIPALITÉ N'APPARAÎT PAS DANS LA LISTE</Typography>
                    <Typography variant="body1">
                        De nouvelles municipalités se joignent régulièrement à Lien Citoyen. Si
                        la vôtre n'est pas encore offerte, écrivez-nous : nous transmettrons
                        l'intérêt à votre municipalité.
                    </Typography>

                    <Typography variant="h5" sx={{pt:3}}>SIGNALER UN PROBLÈME DANS LA VILLE</Typography>
                    <Typography variant="body1">
                        Un nid-de-poule, un lampadaire éteint, un bris d'aqueduc ? Utilisez la
                        fonction <strong>Signalements</strong> de l'application ou du site : votre
                        signalement est transmis directement au service municipal concerné.
                    </Typography>

                    <Typography variant="h5" sx={{pt:3}}>SIGNALER UN PROBLÈME AVEC L'APPLICATION</Typography>
                    <Typography variant="body1">
                        Pour un bogue, un plantage ou un problème d'affichage de l'application
                        elle-même (à distinguer d'un problème municipal, ci-dessus), écrivez-nous
                        à <a href="mailto:info@liencitoyen.com">info@liencitoyen.com</a> en
                        décrivant ce qui s'est passé et, si possible, les étapes pour reproduire
                        le problème.
                    </Typography>

                    <Typography variant="h5" sx={{pt:3}}>SUPPRIMER MON COMPTE</Typography>
                    <Typography variant="body1">
                        Sur l'application mobile, ouvrez <strong>Mon profil</strong> puis{" "}
                        <strong>Supprimer mon compte</strong>. Sur le site Web, écrivez-nous à{" "}
                        <a href="mailto:info@liencitoyen.com">info@liencitoyen.com</a> à partir de
                        l'adresse courriel associée à votre compte pour en demander la
                        suppression.
                    </Typography>

                    <Typography variant="h5" sx={{pt:3}}>CONFIDENTIALITÉ</Typography>
                    <Typography variant="body1">
                        Pour savoir quels renseignements nous recueillons et comment ils sont
                        utilisés, consultez notre{" "}
                        <a href="/politique-confidentialite">politique de confidentialité</a>.
                    </Typography>
                </Grid>
            </Grid>
        </PageStatique>
    );
}
